<template>
  <div>
    <fm-title
      title-text="考核结果"
      :title-menus="[{key: 're', label: '重算结果'}, {key: 'output', label: '导出'}, {key: 'mx', label: '明细'}]"
      @clickTitleMenu="clickTitleMenu">
    </fm-title>
    <fm-table-new
      @on-column-config-update="(columns) => $onTableColumnUpdate(columns, 'main')"
      size="small"
      ref="artable"
      :toolbox="showToolBox"
      :export-file-name="appraisalTitle + '结果'"
      :columns="columns"
      :data-list="bkhList"
      :simple-filter="true"
      emptyPlaceholder="-"
      border="row"
      :stripe="false">
    </fm-table-new>
    <fm-modal
      :value="openDialogMx"
      :mask-closable="false"
      width="80%"
      v-if="openDialogMx"
      theme="mh-withe"
      @cancel="openDialogMx = false">
      <fm-title
        :title-text="appraisalType === 'vote' ? '投票明细' : '得分明细'">
      </fm-title>
      <fm-table-new
        size="small"
        @on-column-config-update="(columns) => $onTableColumnUpdate(columns, appraisalType === 'vote' ? 'vote-details' : 'score-details')"
        :columns="appraisalType === 'vote' ? mxColumnsVote : mxColumns"
        :data-list="mxList"
        :border="true"
        :simple-filter="true"
        :emptyPlaceholder="appraisalType === 'vote' ? '未投票' : '未打分'"
        :stripe="false">
      </fm-table-new>
    </fm-modal>
  </div>
</template>

<script>
import {
  appraisalGroupDetailRequest,
  appraisalResultDetailRequest,
  appraisalGroupRequest
} from '../../../api'

export default {
  name: 'appraisal-result',
  props: {
    appraisalId: {
      type: [String, Number]
    },
    appraisalTitle: {
      type: String
    },
    appraisalType: {
      type: String
    },
    isInc: {
      type: String
    }
  },
  data () {
    return {
      bkhList: [],
      openDialogMx: false,
      checkList: [],
      mxList: []
    }
  },
  computed: {
    showToolBox () {
      return ['table-export', 'table-config'].filter(v => this.$authFunsProxy[v]).map(v => v.replace('table-', ''))
    },
    baseMxColumns () {
      let data = [{field: 'beUserName', title: '', width: 100}].concat(this.checkList.map((v) => {
        return {
          field: this.lm ? 'lm_' + v.id : v.id,
          title: this.isInc === 'yes' ? '**' :v.userName,
          width: 80
        }
      }))
      return data
    },
    mxColumns () {
      return this.$getTableConfig('score-details', this.baseMxColumns)
    },
    baseMxColumnsVote () {
      let data = [{field: 'beUserName', title: '', width: 100}].concat(this.checkList.map((v) => {
        return {
          field: v.id,
          title: this.isInc === 'yes' ? '**' :v.userName,
          render: (h, rowData) => {
            return h('div', rowData[v.id] ? rowData[v.id] : '0')
          }
        }
      }))
      return data
    },
    mxColumnsVote () {
      return this.$getTableConfig('vote-details', this.baseMxColumnsVote)
    },
    baseColumns () {
      let data = [{
        field: 'appraisalGroupName',
        title: '分组',
        width: 150,
        sort: true
      },
      {
        field: 'userName',
        title: '被考核人',
        width: 150,
        sort: true
      },
      {
        field: 'represent',
        title: '代表单位'
      },
      {
        field: 'value',
        title: this.appraisalType === 'vote' ? '票数' : '分值',
        sort: true,
        width: 150,
        dataType: Number
      },
      {
        field: 'ranking',
        title: '名次',
        sort: true,
        width: 150,
        dataType: Number
      }]
      // let a = [{
      //   title: '操作',
      //   slot: 'actions',
      //   width: 100,
      //   fixed: true
      // }]
      return data
    },
    columns () {
      return this.$getTableConfig('main', this.baseColumns)
    },
  },
  methods: {
    dealValue (value) {
      let d = ''
      if (isNaN(value)) {
        try {
          let data = JSON.parse(value)
          if (data && data.length > 0) {
            d = data.filter(v => v.value).map(v => v.value).join('、')
          }
        } catch (error) {
          console.log(error)
          d = ''
        }
      } else {
        d = value
      }
      return d
    },
    loadMxList () {
      this.mxList = []
      let parm = {
        appraisalId: this.appraisalId
      }
      appraisalResultDetailRequest.get(parm).then((data) => {
        let dataMap = {}
        data.forEach((v) => {
          dataMap[v.beAppraisalGroupDetailId] = dataMap[v.beAppraisalGroupDetailId] || {}
          dataMap[v.beAppraisalGroupDetailId][v.appraisalGroupDetailId] = this.dealValue(v.value)
        })
        this.bkhList.forEach((v) => {
          this.mxList.push(Object.assign({
            beUserName: v.userName,
            id: v.id
          }, dataMap[v.id]))
        })
      })
    },
    loadCheckList () {
      let parm = {
        appraisalId: this.appraisalId,
        appraisalGroupType: 'check'
      }
      appraisalGroupDetailRequest.get(parm).then((data) => {
        this.checkList = data
      })
    },
    getValue (value) {
      let d = 0
      if (isNaN(value)) {
        try {
          let data = JSON.parse(value)
          if (data && data.length > 0) {
            data.forEach((v) => {
              if (!isNaN(v.value)) {
                d += Number(v.value)
              } else if (['A', '优', '甲'].includes(v.value)) {
                d += 5
              } else if (['B', '良', '乙'].includes(v.value)) {
                d += 4
              } else if (['C', '中', '丙'].includes(v.value)) {
                d += 3
              } else if (['D', '差', '丁'].includes(v.value)) {
                d += 2
              }
            })
          }
        } catch (error) {
          d = 0
        }
      } else {
        d = Number(value)
      }
      return d
    },
    async tj () {
      this.loading = true
      let parm = {
        appraisalId: this.appraisalId
      }
      let dataMap = {}
      let allData = await appraisalResultDetailRequest.get(parm)
      let dataMap2 = {}
      allData.forEach(v => {
        let key = v.beAppraisalGroupDetailId + '_' + v.appraisalGroupDetailId
        dataMap2[key] = v
      })
      allData = []
      Object.keys(dataMap2).forEach((key) => {
        allData.push(dataMap2[key])
      })
      let groups = await appraisalGroupRequest.get({appraisalId: this.appraisalId})
      let checkWorkers = await appraisalGroupDetailRequest.get({
        appraisalId: this.appraisalId,
        appraisalGroupType: 'check'
      })
      let groupRate = {}
      groups.forEach(v => {
        groupRate[v.id] = v.rule && !isNaN(v.rule) ? Number(v.rule) : 1
      })
      let checkWorkersMap = {}
      checkWorkers.forEach(v => {
        checkWorkersMap[v.id] = {
          rate: groupRate[v.appraisalGroupId],
          all: checkWorkers.filter(v1 => v1.appraisalGroupId === v.appraisalGroupId).map(v2 => v2.id)
        }
      })

      allData.forEach((item) => {
        let value = this.getValue(item.value)
        let dfNum = allData.filter(v => v.beAppraisalGroupDetailId === item.beAppraisalGroupDetailId && checkWorkersMap[item.appraisalGroupDetailId].all.includes(v.appraisalGroupDetailId)).length
        value = value * checkWorkersMap[item.appraisalGroupDetailId].rate / dfNum
        dataMap[item.beAppraisalGroupDetailId] = dataMap[item.beAppraisalGroupDetailId] ? dataMap[item.beAppraisalGroupDetailId].concat([value]) : [value]
      })
      Object.keys(dataMap).forEach((v) => {
        dataMap[v] = dataMap[v].reduce((a, b) => a = a + b, 0)
        dataMap[v] = Number(dataMap[v].toFixed(2))
      })
      let newData = this.bkhList.map(v => Object.assign({}, v))
      let groupMap = {}
      newData.forEach((v) => {
        v.value = dataMap[v.id] || 0
        if (groupMap[v.appraisalGroupId]) {
          groupMap[v.appraisalGroupId].push(v)
        } else {
          groupMap[v.appraisalGroupId] = [v]
        }
      })
      Object.keys(groupMap).forEach(v => groupMap[v].sort((a,b) => (b.value || -1) - (a.value || -1)))
      let i = 0
      let keys = Object.keys(groupMap)
      while (i < keys.length) {
        let j = 0
        while (j < groupMap[keys[i]].length) {
          let same = j > 0 && groupMap[keys[i]][j].value == groupMap[keys[i]][j - 1].value
          if (groupMap[keys[i]][j].value) {
            groupMap[keys[i]][j].ranking = same ? groupMap[keys[i]][j - 1].ranking : j + 1
            if (j === 0) {
              groupMap[keys[i]][j].gotta = '该组第一名'
            } else if (groupMap[keys[i]][j].ranking === groupMap[keys[i]][0].ranking) {
              groupMap[keys[i]][j].gotta = '该组第一名'
            } else {
              groupMap[keys[i]][j].gotta = ''
            }
          } else {
            groupMap[keys[i]][j].gotta = null
            groupMap[keys[i]][j].ranking = same ? groupMap[keys[i]][j - 1].ranking : j + 1
          }
          await appraisalGroupDetailRequest.update(groupMap[keys[i]][j].id, groupMap[keys[i]][j])
          j += 1
        }
        i += 1
      }
      this.loading = false
      this.loadData()
    },
    clickTitleMenu (parm) {
      if (parm === 're') {
        this.tj()
      } else if (parm === 'mx') {
        this.loadMxList()
        this.openDialogMx = true
      } else if (parm === 'output') {
        this.$refs.artable.openExport()
      }
    },
    loadData () {
      let parm = {
        appraisalId: this.appraisalId,
        appraisalGroupType: 'becheck'
      }
      appraisalGroupDetailRequest.get(parm).then((data) => {
        data.sort((a, b) => (a.ranking || 1000) - (b.ranking || 1000))
        this.bkhList = data
      })
    }
  },
  created () {
    if (this.appraisalId) {
      this.loadData()
      this.loadCheckList()
    }
  }
}
</script>

<style lang="less" scoped>
</style>